import React from 'react';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { LoaderDots } from '@bubble-ui/molecule-loader-dots';
import { Loader as LoaderSpinner } from './Loader';
var OneLoader = props => {
  var Loader = !props.small && props.large ? LoaderDots : LoaderSpinner;
  return /*#__PURE__*/React.createElement(Loader, props);
};
OneLoader.displayName = 'Loader';
var Loader = withProvisionalOverrideFromContext(OneLoader);
export default Loader;

/**
 * @deprecated this type export will be removed with v6.0.0
 */

/**
 * @deprecated this export will be removed with v6.0.0
 */
export { getPostFix, loaderSizes } from './utils';
//# sourceMappingURL=index.js.map